import { defineComponent as _defineComponent } from 'vue';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import { reactive, ref } from 'vue';
import { helpers, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { trans } from 'laravel-vue-i18n';
import { enumToDropdownOptions, processDataForm, } from '../../../Services/Utils';
import { AffectedLeaves, AffectedZone } from '../../../@types/Enums';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
import { useMitt } from '../../../Plugins/mitt';
import { DateTime } from 'luxon';
import DocumentsForm from '../../../Components/DocumentsForm.vue';
import InputTextarea from '../../../Components/InputTextarea.vue';
import Button from 'primevue/button';
import SymptomService from '../../../Services/SymptomService';
import ToggleButton from 'primevue/togglebutton';
import RecordBasicInfo from '../RecordBasicInfo.vue';
import Message from 'primevue/message';
import SymptomRecordService from '../../../Services/SymptomRecordService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['update:modelValue', 'cancel', 'saved'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const symptomRecordService = new SymptomRecordService();
        const documentsForm = ref();
        const newDocuments = ref([]);
        const defaultDate = (props.data.date
            ? DateTime.fromISO(props.data.date, { zone: 'utc' })
            : DateTime.now()).toJSDate();
        const data = reactive({
            id: props.data.id,
            orchard_id: undefined,
            plot_ids: [],
            description: props.data.description || '',
            date: defaultDate,
            affected_zone: props.data.affected_zone,
            affected_leaves: props.data.affected_leaves,
            notes: props.data.notes,
            symptom_record_values: props.data.symptom_record_values || [],
        });
        if (props.data.plots && props.data.plots.length > 0) {
            data.orchard_id = props.data.plots[0].orchard_id;
        }
        const rules = {
            orchard_id: { required },
            plot_ids: { required },
            description: { required },
            date: { required },
            affected_zone: { required },
            affected_leaves: { required },
            notes: {},
            symptom_record_values: {
                required,
                $each: helpers.forEach({
                    symptom: { required },
                    symptom_id: { required },
                    value: { required },
                }),
            },
        };
        const v$ = useVuelidate(rules, data);
        const affectedZoneOptions = enumToDropdownOptions(AffectedZone, 'AffectedZone', false);
        const affectedLeavesOptions = enumToDropdownOptions(AffectedLeaves, 'AffectedLeaves', false);
        const symptomOptions = ref([]);
        new SymptomService().getAll().then((options) => {
            options.forEach((option) => {
                option.translatedName = trans(`symptoms.${option.name}`);
            });
            options.sort((a, b) => a.translatedName.localeCompare(b.translatedName));
            symptomOptions.value = options;
            if (props.data.symptom_record_values &&
                props.data.symptom_record_values.length > 0) {
                data.symptom_record_values = props.data.symptom_record_values.map((symptomRecordValue) => {
                    symptomRecordValue.symptom = options.find((option) => option.id === symptomRecordValue.symptom_id);
                    return symptomRecordValue;
                });
            }
        });
        const addSymptomRecordValue = () => {
            data.symptom_record_values.push({ symptom: null, value: null });
        };
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            documentsForm.value.upload();
            const formData = processDataForm(data, newDocuments.value, props.data.documents);
            data.symptom_record_values.forEach((el) => {
                formData.append('symptom_record_values[]', JSON.stringify(el));
            });
            symptomRecordService.save(formData, data.id).then((data) => {
                emit('saved', data);
                emitter.emit('symptom-record-saved', data);
            });
        };
        const getSymptomDropdownOptions = (symptom) => {
            if (symptom.type === 'enum') {
                return symptom.values.split(',').map((value) => ({
                    label: trans(`enums.${symptom.name}.${value}`),
                    value,
                }));
            }
            return [];
        };
        const symptomChanged = (symptomRecordValue) => {
            symptomRecordValue.symptom.type === 'bool'
                ? (symptomRecordValue.value = false)
                : (symptomRecordValue.value = undefined);
        };
        const __returned__ = { emitter, symptomRecordService, props, emit, documentsForm, newDocuments, defaultDate, data, rules, v$, affectedZoneOptions, affectedLeavesOptions, symptomOptions, addSymptomRecordValue, save, getSymptomDropdownOptions, symptomChanged, get Dropdown() { return Dropdown; }, get MultiSelect() { return MultiSelect; }, get required() { return required; }, get trans() { return trans; }, SaveCancelButtons, DocumentsForm, InputTextarea, get Button() { return Button; }, get ToggleButton() { return ToggleButton; }, RecordBasicInfo, get Message() { return Message; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
